import { openUrl } from '@/features/earn-x/utils/openUrl'
import { cn } from '@/shared/lib/utils'
import { Layout } from '@/shared/wrappers/Layout'
import { Button } from '@/ui/button'
import { Image } from '@/ui/image'
import { StarfieldBackground } from '@/ui/starfield-background'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/banned')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('app')
  return (
    <Layout
      className="flex flex-col gap-6 items-center justify-center"
      safeX="safe"
      safeY="safe"
      width={'full'}
      height={'full-height'}
    >
      <StarfieldBackground amount={300} speed={8} scrollBoost={4} />
      <Image src={'meeesh-logo.svg'} width={58} height={32} className="mb-6" />
      <div className="flex flex-col items-center text-center justify-center gap-2">
        <h1 className="text-x28 font-bold whitespace-pre-wrap">
          {t('banned.title')}
        </h1>
        <p className=" text-x18 text-[#8c8c8c] whitespace-pre-wrap">
          {t('banned.subtitle')}
        </p>
      </div>
      <Button
        variant="secondary"
        size="md"
        className={cn('px-8 mt-6')}
        onClick={() =>
          openUrl(`https://t.me/${import.meta.env.VITE_SUPPORT_BOT_USERNAME}`)
        }
      >
        {t('banned.contact_support_button')}
      </Button>
    </Layout>
  )
}
